import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';

import { useLanguage } from '../../contexts/LanguageContext';
import { DOCUMENT_TYPES } from './documentTypes';

/**
 * First step of the document capture flow: which document is being presented.
 *
 * The list is static for now. Phase 9 replaces it with the live template
 * catalogue served through IdMe.
 */
function DocumentTypeSelection({ onContinue, onCancel }) {
  const { t } = useLanguage();
  const copy = t.documentCapture;

  const [selected, setSelected] = useState(DOCUMENT_TYPES[0]);

  return (
    <Box className="docCapture__panel">
      <Typography className="docCapture__eyebrow">{copy.select.eyebrow}</Typography>

      <Typography variant="h1" className="docCapture__title">
        {copy.select.title}
      </Typography>

      <Typography className="docCapture__subtitle">{copy.select.subtitle}</Typography>

      <Box
        className="docCapture__options"
        role="radiogroup"
        aria-label={copy.select.title}
      >
        {DOCUMENT_TYPES.map((documentType) => {
          const isSelected = selected === documentType;

          return (
            <label
              key={documentType}
              className={`docCapture__option${isSelected ? ' is-selected' : ''}`}
            >
              <input
                type="radio"
                name="docCapture_documentType"
                value={documentType}
                checked={isSelected}
                onChange={() => setSelected(documentType)}
              />
              <span>{copy.documentTypes[documentType]}</span>
            </label>
          );
        })}
      </Box>

      <Button
        fullWidth
        variant="contained"
        className="docCapture__primaryAction"
        onClick={() => onContinue(selected)}
        sx={{
          backgroundColor: '#1818de',
          py: 1.5,
          borderRadius: '12px',
          fontSize: { xs: 18, sm: 20 },
          fontWeight: 600,
          color: '#fff',
          textTransform: 'none',
          '&:hover': { backgroundColor: '#1515b0' },
        }}
      >
        {copy.select.continue}
      </Button>

      {onCancel ? (
        <Button
          className="docCapture__secondaryAction"
          onClick={onCancel}
          sx={{ mt: 1, textTransform: 'none', color: '#777' }}
        >
          {copy.capture.cancel}
        </Button>
      ) : null}
    </Box>
  );
}

export default DocumentTypeSelection;
